module.exports = __webpack_public_path__ + "img/c-1.d0e0d1fe.jpg";